<template>
  <div class="home">
    <!-- ============ Hero 区 ============ -->
    <section class="hero" v-loading="loading">
      <div class="container hero-frame">
        <div class="hero-bg"></div>
        <div class="hero-mask"></div>
        <div class="hero-inner">
          <div class="hero-text">
            <p class="hero-eyebrow">湖南中云图地理信息科技有限公司</p>
            <h1 class="hero-title">无人机航测 · 三维地理信息 · 天空地技术应用</h1>
            <div class="hero-actions">
              <router-link class="btn btn-primary" to="/goin">走进中云图</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ 三列资讯区 ============ -->
    <section class="news-trio">
      <div class="container">
        <div class="trio-grid">
          <div class="trio-col" v-for="col in newsCols" :key="col.title">
            <SectionTitle :title="col.title" :subtitle="col.subtitle" :more="col.more" />
            <ul class="trio-list">
              <li v-for="item in col.list" :key="item.Id">
                <router-link :to="{ name: 'newsdetails', params: { id: item.Id } }" class="trio-link">
                  <span class="trio-dot"></span>
                  <span class="trio-text">{{ item.Title }}</span>
                  <span class="trio-date">{{ formatDate(item.CreateTime) }}</span>
                </router-link>
              </li>
              <li v-if="!col.list.length" class="trio-empty">暂无数据</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ 产品中心 ============ -->
    <section class="business">
      <div class="container">
        <SectionTitle title="产品中心" subtitle="PRODUCTS" more="/product" />
        <div class="business-grid" v-if="productList.length">
          <router-link
            v-for="item in displayProducts"
            :key="item.Id"
            class="business-card"
            :to="{ name: 'productdetails', params: { id: item.Id } }"
          >
            <div class="business-cover" v-lazy:background-image="$img(item.Img)"></div>
            <div class="business-body">
              <h4>{{ item.Title }}</h4>
              <p>{{ item.Summary || stripHtml(item.Content) }}</p>
              <span class="more">查看详情 &gt;</span>
            </div>
          </router-link>
        </div>
        <p v-else-if="!loading" class="empty-tip">暂无产品，请先在后台添加。</p>
      </div>
    </section>

    <!-- ============ 经典案例 ============ -->
    <section class="cases-block">
      <div class="container">
        <SectionTitle title="经典案例" subtitle="CASES" more="/case" />
        <div class="cases-grid" v-if="displayCases.length">
          <router-link
            v-for="item in displayCases"
            :key="item.Id"
            :to="{ name: 'casedetails', params: { id: item.Id } }"
            class="case-card"
          >
            <div class="case-cover" v-lazy:background-image="$img(item.Img)"></div>
            <div class="case-body">
              <h4>{{ item.Title }}</h4>
              <span class="case-arrow">查看详情 &gt;</span>
            </div>
          </router-link>
        </div>
        <p v-else-if="!loading" class="empty-tip">暂无案例，请先在后台添加。</p>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from "../components/SectionTitle";

export default {
  name: "Home",
  components: { SectionTitle },
  data() {
    return {
      loading: true,
      caseList: [],
      productList: [],
      newsList1: [],
      newsList2: [],
      newsList3: []
    };
  },
  computed: {
    displayCases() {
      return (this.caseList || []).slice(0, 6);
    },
    displayProducts() {
      return (this.productList || []).slice(0, 6);
    },
    newsCols() {
      return [
        { title: "通知公告", subtitle: "NOTICE", more: "/news?type=3", list: this.newsList1 },
        { title: "公司新闻", subtitle: "NEWS", more: "/news?type=1", list: this.newsList2 },
        { title: "行业动态", subtitle: "TRENDS", more: "/news?type=2", list: this.newsList3 }
      ];
    }
  },
  mounted() {
    this.$http
      .all([
        this.$http.get("Case"),
        this.$http.get("Product"),
        this.$http.get("News/Search?type=3&count=5"),  // 通知公告
        this.$http.get("News/Search?type=1&count=5"),  // 公司新闻
        this.$http.get("News/Search?type=2&count=5")   // 行业动态
      ])
      .then(
        this.$http.spread((resCase, resProduct, resN1, resN2, resN3) => {
          this.caseList = (resCase.data || []).slice(0, 6);
          this.productList = (resProduct.data || []).slice(0, 6);
          this.newsList1 = (resN1.data || []).slice(0, 5);  // 通知公告
          this.newsList2 = (resN2.data || []).slice(0, 5);  // 公司新闻
          this.newsList3 = (resN3.data || []).slice(0, 5);  // 行业动态
          this.loading = false;
        })
      )
      .catch(() => {
        this.loading = false;
      });
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      const t = new Date(value);
      if (Number.isNaN(t.getTime())) return value;
      const m = `${t.getMonth() + 1}`.padStart(2, "0");
      const d = `${t.getDate()}`.padStart(2, "0");
      return `${t.getFullYear()}-${m}-${d}`;
    },
    stripHtml(html) {
      if (!html) return "";
      // 富文本 → 纯文本:浏览器解码 HTML 实体(&nbsp; &amp; &lt; 等),再合并空白
      // 注意 &nbsp; 解码后是 U+00A0 不间断空格,JS 的 \s 不匹配,需显式列出
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const text = (tmp.textContent || "")
        .replace(/[\s\u00A0\u3000]+/g, " ")
        .trim();
      return text.length > 60 ? text.slice(0, 60) + "..." : text;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.home {
  width: 100%;
  background: $color-bg-2;
}

// ===== Hero ===== //
.hero {
  padding-top: 28px;
}

.hero-frame {
  position: relative;
  height: 420px;
  overflow: hidden;
  background: $color-primary-deep;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}

.hero-mask {
  position: absolute;
  inset: 0;
  background: rgba(10, 37, 64, 0.45);
}

.hero-inner {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-text {
  width: 100%;
  max-width: 760px;
  color: #fff;
  padding: 0 24px;
  text-align: center;
}

.hero-eyebrow {
  margin: 0 0 14px;
  font-size: 14px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.85);
}

.hero-title {
  margin: 0;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 4px;
  line-height: 1.3;
}

.hero-actions {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  gap: 14px;
}

.btn {
  display: inline-block;
  padding: 11px 28px;
  font-size: 14px;
  letter-spacing: 2px;
  text-decoration: none;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.btn-primary {
  background: $color-accent;
  color: #fff;
  border-color: $color-accent;
  &:hover {
    background: $color-accent-dark;
    border-color: $color-accent-dark;
    color: #fff;
  }
}

.btn-outline {
  background: transparent;
  color: #fff;
  border-color: #fff;
  &:hover {
    background: #fff;
    color: $color-primary-deep;
  }
}

// ===== 三列资讯 ===== //
.news-trio {
  padding: 48px 0 0;
}

.trio-grid {
  display: grid;
  // minmax(0, 1fr) 强制 3 等宽:不让内容撑大某列把别的列压扁
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  // 默认 stretch 让 3 列等高,内容少的那列卡片背景/边框跟其他列齐平
}

.trio-col {
  background: #fff;
  border: 1px solid $color-border;
  padding: 22px 24px 18px;
  // grid item 显式 min-width:0,避免被内部 .trio-list/.section-title 等内容的 min-content 撑大
  min-width: 0;
}

.trio-list {
  li {
    border-bottom: 1px dashed $color-border;
    &:last-child { border-bottom: none; }
  }
}

.trio-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 0;
  color: $color-text;
  // flex 容器必须显式 min-width:0,否则 min-content(标题不换行宽 + 日期宽)会把自身撑大,连带把 .trio-col 也撑出容器
  min-width: 0;

  &:hover { color: $color-accent; }
}

.trio-dot {
  width: 4px;
  height: 4px;
  background: $color-accent;
  flex-shrink: 0;
}

.trio-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.trio-date {
  color: $color-text-3;
  font-size: 12px;
  flex-shrink: 0;
}

.trio-empty {
  padding: 24px 0;
  text-align: center;
  color: $color-text-3;
  font-size: 13px;
}

// ===== 产品中心 ===== //
.business {
  padding: 48px 0 0;
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  margin-top: 8px;
}

.business-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid $color-border;
  color: $color-text;
  transition: border-color 0.2s ease;
  // grid item 显式 min-width:0,避免被内部 h4/p 的 min-content 撑大
  min-width: 0;

  &:hover {
    border-color: $color-accent;
    color: $color-accent;
  }
}

.business-cover {
  width: 100%;
  height: 180px;
  background: #e8e8e8 center / cover no-repeat;
  border-bottom: 1px solid $color-border;
}

.business-body {
  padding: 16px 24px 18px;
  flex: 1;
  display: flex;
  flex-direction: column;

  h4 {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // h4 默认 block,min-width:auto = 标题不换行的整段宽,加 0 让 ellipsis 真正生效
    min-width: 0;
  }

  p {
    margin: 0 0 12px;
    color: $color-text-2;
    font-size: 13px;
    line-height: 1.75;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    min-height: 44px;
  }
}

.business-body .more {
  margin-top: auto;
  color: $color-accent;
  font-size: 13px;
  letter-spacing: 1px;
}

.empty-tip {
  margin: 8px 0 0;
  padding: 60px 0;
  text-align: center;
  color: $color-text-3;
  font-size: 13px;
  background: #fff;
  border: 1px solid $color-border;
}

// ===== 经典案例 ===== //
.cases-block {
  padding: 48px 0 52px;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
}

.case-card {
  background: #fff;
  border: 1px solid $color-border;
  display: block;
  color: $color-text;
  transition: border-color 0.2s ease;
  // grid item 显式 min-width:0,避免被 .case-body h4 长标题撑大(默认 min-width:auto = min-content)
  min-width: 0;

  &:hover {
    border-color: $color-accent;
    color: $color-accent;
  }
}

.case-cover {
  width: 100%;
  height: 140px;
  background-color: #ddd;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-bottom: 1px solid $color-border;
}

.case-body {
  padding: 16px 24px;

  h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // h4 默认 block 元素 min-width:auto = min-content(标题不换行),加 0 让 ellipsis 真正生效
    min-width: 0;
  }
}

.case-arrow {
  display: inline-block;
  margin-top: 8px;
  font-size: 12px;
  color: $color-accent;
  letter-spacing: 1px;
}

// ===== 响应式 ===== //
@media (max-width: 960px) {
  .hero-frame { height: 340px; }
  .hero-text { padding: 0 20px; }
  .hero-title { font-size: 26px; letter-spacing: 3px; }
  .hero-eyebrow { font-size: 13px; letter-spacing: 3px; }

  .trio-grid { grid-template-columns: 1fr; gap: 18px; }
  .trio-col { width: 100%; }            // 移动端单列:卡片必须填满容器,不留白
  .case-card { width: 100%; }           // 同上,案例卡片
  .business-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
  .cases-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
}

@media (max-width: 640px) {
  .hero-frame { height: 300px; }
  .hero-text { padding: 0 16px; }
  .hero-title { font-size: 20px; letter-spacing: 2px; line-height: 1.4; }
  .hero-eyebrow { font-size: 12px; letter-spacing: 2px; }
  .hero-actions { margin-top: 24px; }
  .btn { padding: 10px 22px; font-size: 13px; }
  .business-grid { grid-template-columns: 1fr; }
  .cases-grid { grid-template-columns: 1fr; }
}
</style>
